export default __webpack_public_path__ + "static/media/Barlow-Bold.0cb1ab86.ttf";